import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import SandboxEchoPageQuery from '@atlassian/jira-relay/src/__generated__/SandboxEchoPageQuery.graphql';

export const sandboxEchoPageEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-sandbox-echo-page", jiraSpaEntry: "jira-spa-sandboxdemo" */ './ui/SandboxEchoPage.tsx'
			),
	),
	getPreloadProps: ({ tenantContext, context: routerContext }: EntryPointRouteParams) => {
		return {
			queries: {
				pageQueryRef: {
					parameters: SandboxEchoPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						enableDefer: Boolean(
							'defer' in routerContext.query ? routerContext.query.defer === 'true' : true,
						),
						skipLongQuery: Boolean(
							'skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true,
						),
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
